module.exports = __webpack_public_path__ + "static/img/szafa_dso_36.7062c77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/kopai/szafa_dso_36.svg
// module id = G2Qg
// module chunks = 1